import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
	DataByTableTypeProvider,
	DeleteWorkfileService,
	NormalizeFormValueService,
	PrimaryKeyService,
	PingServerService,
	SamplesService,
	SampleTypeProvider,
	TableTypeProvider
} from './services';
import { SamplesTableProvider, SamplesTableResolver } from './samples';
import { StandardTableProvider, StandardTableResolver } from './standards';
import { EntryBllService } from './entry';
import { DeleteIntervalService, DeleteValidatorsOrchestratorService } from './entry/delete-validations/services';
import { SortingService } from './services';
import { CheckoutSanitizer, CheckoutService, CopyinCheckinCheckoutService } from './entity';

@NgModule({
	declarations: [],
	providers: [
		CopyinCheckinCheckoutService,
		SampleTypeProvider,
		SamplesService,
		StandardTableProvider,
		StandardTableResolver,
		SamplesTableProvider,
		SamplesTableResolver,
		TableTypeProvider,
		EntryBllService,
		DeleteValidatorsOrchestratorService,
		DeleteIntervalService,
		SortingService,
		TableTypeProvider,
		DataByTableTypeProvider,
		NormalizeFormValueService,
		DeleteWorkfileService,
		PingServerService,
		CheckoutService,
		PrimaryKeyService,
		CheckoutSanitizer
	],
	imports: [CommonModule]
})
export class BusinessLayerModule {}
